export type MenuSectionId =
  | 'clases'
  | 'eventos'
  | 'lector_qr'
  | 'mensajes'
  | 'alquileres'
  | 'mi_saldo'
  | 'mis_facturas'
  | 'incidencias'
  | 'entrega'
  | 'recaudacion'
  | 'domotica'
  | 'liquidacion'

export interface MenuSectionConfig {
  id: MenuSectionId
  label: string
  path: string
  external?: boolean
}

const STORAGE_KEY = 'menu-usage-v1'

export const TRACKED_MENU_SECTIONS: MenuSectionConfig[] = [
  { id: 'clases', label: 'Clases', path: '/sesiones' },
  { id: 'eventos', label: 'Eventos', path: '/eventos' },
  { id: 'lector_qr', label: 'Lector QR', path: 'https://escaner.gest.galidancia.com', external: true },
  { id: 'mensajes', label: 'Mensajes', path: '/mensajes' },
  { id: 'alquileres', label: 'Alquileres', path: '/alquileres' },
  { id: 'mi_saldo', label: 'Mi Saldo', path: '/saldo' },
  { id: 'mis_facturas', label: 'Mis facturas', path: '/mis-facturas' },
  { id: 'incidencias', label: 'Incidencias', path: '/Organizacion/incidencias' },
  { id: 'entrega', label: 'Entrega', path: '/entrega' },
  { id: 'recaudacion', label: 'Recaudación', path: '/recaudacion' },
  { id: 'domotica', label: 'Domótica', path: '/domotica' },
  { id: 'liquidacion', label: 'Liquidación', path: '/liquidacion' },
]

const emptyCounters = (): Record<MenuSectionId, number> => ({
  clases: 0,
  eventos: 0,
  lector_qr: 0,
  mensajes: 0,
  alquileres: 0,
  mi_saldo: 0,
  mis_facturas: 0,
  incidencias: 0,
  entrega: 0,
  recaudacion: 0,
  domotica: 0,
  liquidacion: 0,
})

export const getMenuUsageCounters = (): Record<MenuSectionId, number> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return emptyCounters()
    const parsed = JSON.parse(raw) as Partial<Record<MenuSectionId, number>>
    return {
      ...emptyCounters(),
      ...parsed,
    }
  } catch (error) {
    return emptyCounters()
  }
}

export const trackMenuAccess = (sectionId: MenuSectionId): void => {
  const counters = getMenuUsageCounters()
  counters[sectionId] = (counters[sectionId] || 0) + 1
  localStorage.setItem(STORAGE_KEY, JSON.stringify(counters))
}

export const getTopMenuSections = (limit = 8): MenuSectionConfig[] => {
  const counters = getMenuUsageCounters()
  return TRACKED_MENU_SECTIONS
    .filter((section) => (counters[section.id] || 0) > 0)
    .sort((a, b) => (counters[b.id] || 0) - (counters[a.id] || 0))
    .slice(0, limit)
}
